import Modal from 'antd/es/modal/Modal'
import IdeyaTypography from './ideya-typography.tsx'
import Divider from 'antd/es/divider'
import React from 'react'
import { IdeyaButton } from './ideya-button/ideya-button.tsx'
import { useTranslation } from 'react-i18next'

interface IdeyaModalProps extends React.ComponentProps<typeof Modal> {
  isForm?: boolean
  children?: React.ReactNode
}

const IdeyaModal: React.FC<IdeyaModalProps> = (props) => {
  const { isForm = false, children, ...modalProps } = props
  const { t } = useTranslation()

  return (
    <Modal
      destroyOnHidden={true}
      keyboard={true}
      title={
        <>
          <IdeyaTypography.Text size={'lg'}>{props.title}</IdeyaTypography.Text>
          <Divider />
        </>
      }
      maskClosable={false}
      footer={
        !isForm && (
          <>
            <IdeyaButton
              ghost
              onClick={props.onCancel}
              disabled={props.confirmLoading}
            >
              {t('common.cancel')}
            </IdeyaButton>
            <IdeyaButton onClick={props.onOk} loading={props.confirmLoading}>
              {t('common.ok')}
            </IdeyaButton>
          </>
        )
      }
      {...modalProps}
    >
      {children}
    </Modal>
  )
}

export default IdeyaModal
